export default __webpack_public_path__ + "static/media/site-logo.7c54b9d1.png";